import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'

import { PurchaseRequestDetailDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import LegacyApprovalLayout from 'modules/procurement/pages/PurchaseRequestDetailPage/LegacyApprovalLayout'
import WorkflowApprovalLayout from 'modules/procurement/pages/PurchaseRequestDetailPage/WorkflowApprovalLayout'

const MyPurchaseRequestDetailSummaryPage = () => {
  const { id } = useParams()
  const { company } = useCurrentSession()

  const { loading, data, error } = useQuery(PurchaseRequestDetailDocument, {
    variables: {
      companyId: company.id,
      id: Number(id),
    },
  })

  const purchaseRequest = data?.procurement?.purchaseRequest
  const canSeePurchaseRequests = data?.procurement?._policies?.purchaseRequestRead.can ?? false

  // Workaround to force the ApprovalsInformationBlock to re-render once the purchase request is reviewed
  const [renderApprovalsKey, setRenderApprovalsKey] = React.useState(0)

  useEffect(() => {
    setRenderApprovalsKey((prevKey) => prevKey + 1)
  }, [purchaseRequest?.approval])

  const isWorkflowsEnabled =
    data?.features?.featuresConnection?.nodes?.some(
      (feature) => feature.name === 'dev_procurement_approval_workflows' && feature.enabled
    ) || false

  const timelineEntries = data?.procurement?.approvalsTimelines?.[0]?.entries ?? []

  const shouldDisplayNewUi = isWorkflowsEnabled && timelineEntries.length > 0

  return (
    <ResponsivePage.Body
      variant="wide"
      authorized={canSeePurchaseRequests}
      loading={loading}
      error={error}
    >
      {purchaseRequest &&
        (shouldDisplayNewUi ? (
          <WorkflowApprovalLayout
            purchaseRequest={purchaseRequest}
            timelineEntries={timelineEntries}
          />
        ) : (
          <LegacyApprovalLayout
            purchaseRequest={purchaseRequest}
            renderApprovalsKey={renderApprovalsKey}
          />
        ))}
    </ResponsivePage.Body>
  )
}

export default MyPurchaseRequestDetailSummaryPage
